var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4511_11112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99923 14.6635C11.6803 14.6635 14.6645 11.6794 14.6645 7.99825C14.6645 4.31714 11.6803 1.33301 7.99923 1.33301C4.31812 1.33301 1.33398 4.31714 1.33398 7.99825C1.33398 11.6794 4.31812 14.6635 7.99923 14.6635Z",
    stroke: "#FF5722",
    strokeWidth: 1.33305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 5.33203V7.99813",
    stroke: "#FF5722",
    strokeWidth: 1.33305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 10.6641H8.00471",
    stroke: "#FF5722",
    strokeWidth: 1.33305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4511_11112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9966,
    height: 15.9966,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_Warning.84de1d7df5ad180623b78998a5147abb.svg";
export { ForwardRef as ReactComponent };